import PieChartIcon from '@assets/icons-png/cropped_icons_with_padding/icon_49.png';
import PageContainer from "@components/layout/PageContainer";
import DashboarLinksSection, { DashboardLinksSectionProps } from "@components/content/DashboardLinksSection";
import ProvidersReportOffCanvas from "@components/layout/Offcanvas/ProvidersReportOffCanvas";
import { OpenProvidersReportPubSub } from "@utils/pubsubs/PubSub";

const ProvidersDashboard = () => {

  const groupLinks: DashboardLinksSectionProps[] = [
    {
      title: "Reportes Generales",
      links: [
        {
          icon: PieChartIcon,
          iconAlt: "Icono Reporte de Proveedores",
          title: "Reporte de Proveedores (Excel)",
          url: "#",
          onClick: () => {
            OpenProvidersReportPubSub.publish({ openOffCanvas: true })
          }
        }
      ]
    }
  ]

  return (
    <PageContainer
      title="Reportes de Proveedores"
      backUrl="/user/providers"
    >
      {
        groupLinks.map((gl, index) => {
          return (
            <DashboarLinksSection
              key={`group-${index}`}
              title={gl.title}
              links={gl.links}
            />
          )
        })
      }
      <ProvidersReportOffCanvas />
    </PageContainer>
  );
}

export default ProvidersDashboard;
